import * as API from "@/services/API";

export default {
  getMain(Id) {
    return API.apiClient.get(`/fmain/${Id}`);
  },
  getMains() {
    return API.apiClient.get(`/fmain/`);
  },
  postMain(payload) {
    return API.apiClient.post(`/fmain/`, payload);
  },
  updateMain(Id, payload) {
    return API.apiClient.put(`/fmain/${Id}`, payload);
  },
  deleteMain(Id) {
    return API.apiClient.delete(`/fmain/${Id}`);
  },
};
